'use strict';

require('./FormGroupTextFieldSuggested.scss');
const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    PropTypes = React.PropTypes,
    set = require('lodash/object').set,
    get = require('lodash/object').get,
    {find, map, some} = require('lodash/collection'),
    ContentUtils = require('../../../../utils/ContentUtils'),
    BasicFormGroup = require('../BasicFormGroup'),
    TextFieldSuggested = require('../../../../components/Commons/TextField/TextFieldSuggested/TextFieldSuggested');


const FormGroupTextFieldSuggested = React.createClass({displayName: "FormGroupTextFieldSuggested",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        
        placeHolder: PropTypes.string,
        items: PropTypes.array,
        itemsDisabled: PropTypes.array,
        label: PropTypes.string,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        messageError: PropTypes.string,
        name: PropTypes.string,
        customErrorNonMatch: PropTypes.string,
        isRequired: PropTypes.bool,
        onEnter: PropTypes.func,

        /**
         * The current selected object
         */
        value: PropTypes.object,

        // Input param -----------

        /**
         * The field which use to display the value
         */
        readerAttribute: PropTypes.string,

        // Output param -------------

        /**
         * Just in case which need to save a custom value
         */
        readerAttributeValue: PropTypes.string,

        writerAttribute: PropTypes.string,
        isImmutable: PropTypes.bool,

        onItemSelected: PropTypes.func
    }),


    getInitialState() {
        return {
            itemSelected: null,
            textWritten: ''
        };
    },

    componentDidMount() {
        const {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
    },

    clean() {
        if (this.isMounted()) {
            this.getDOMNode().querySelector('input').value = '';
        }
    },

    getValue() {
        const {writerAttribute, readerAttribute, readerAttributeValue, value} = this.props;
        const {itemSelected} = this.state;

        const isEditMode = !!value;
        const writerAttributeSafe = writerAttribute || readerAttribute; // make writer attribute optionally
        const readerAttributeSafe = readerAttributeValue || readerAttribute; // make writer attribute optionally

        let valueToSave;
        if (itemSelected) {
            // first check internal state
            valueToSave = get(this.state, `itemSelected.${readerAttributeSafe}`);
        } else if (isEditMode) {
            valueToSave = get(value, readerAttributeSafe);
        }

        const wrapper = set({}, writerAttributeSafe, valueToSave);

        return wrapper;
    },

    isValid() {
        const messageError = this._getErrorInfo();
        this.setState({messageError: messageError});
        return messageError === '';
    },

    _getErrorInfo() {
        let {additionalValidation, isRequired, readerAttributeValue, readerAttribute, items, writerAttribute, value, name, customErrorNonMatch} = this.props;
        const {textWritten, itemSelected} = this.state;
        if (ContentUtils.isNull(isRequired)) {
            isRequired = true;
        }

        name = name || 'item';
        const inputValue = this.getValue();

        let messageError = '';
        if (itemSelected) {
            // enter here when item are selected
            const matchAnyItem = this._isTextWrittenMatchSomeItem(items, readerAttribute, textWritten);
            if (!matchAnyItem) {
                if (customErrorNonMatch) {
                    messageError = customErrorNonMatch;
                } else {
                    messageError = `${name} ${t('notification_not_exist')}`;
                }
            }
        } else if (isRequired && inputValue) {
            // enter here when the item are non-selected
            // but exist some value entered by the consumer
            const writerAttributeSafe = writerAttribute || readerAttribute;
            const itemValue = inputValue ? get(inputValue, writerAttributeSafe) : get(value, writerAttributeSafe);

            if (!itemValue) {
                if (customErrorNonMatch) {
                    messageError = customErrorNonMatch;
                } else {
                    messageError = `${name} ${t('notification_not_exist')}`;
                }
            } else {
                const itemTarget = find(items, item => get(item, readerAttributeValue) === itemValue);
                if (!itemTarget) {
                    messageError = `${t('label_the')} ${name} ${t('notification_is_required')}`;
                }
            }
        }

        if (!messageError && additionalValidation) {
            messageError = additionalValidation(inputValue);
        }

        return messageError;
    },

    _isTextWrittenMatchSomeItem(items, readerAttribute, textWritten) {
        return some(map(items, vendor => get(vendor, readerAttribute)), text => text === textWritten);
    },

    _onEnter() {
        if (this.props.onEnter) {
            this.props.onEnter();
        }
    },

    _onBlur(itemSelected, textWritten) {
        const {onBlur, readerAttribute} = this.props;
        const safeTextWritten = ContentUtils.isEmptyText(textWritten) ? get(itemSelected, readerAttribute) : textWritten;
        this.setState({
            itemSelected,
            textWritten: safeTextWritten
        }, () => {
            if (onBlur) {
                onBlur(itemSelected, textWritten);
            }
            this.isValid();
        });
    },

    onItemSelected(itemSelected) {
        const textWritten = get(itemSelected, this.props.readerAttribute);
        this.setState({
            itemSelected,
            textWritten
        }, () => this.isValid());

        if(this.props.onItemSelected) {
            this.props.onItemSelected(itemSelected);
        }
    },

    render() {
        const {isDisabled, label, onChange, value, readerAttribute, isDark, isImmutable, isEditMode, items, itemsDisabled} = this.props;

        // is disabled input
        const isDisabledInput = !!isDisabled || isImmutable && isEditMode;

        // prepare specific classes
        let textFieldClassName = 'form-group form-group-textfield-suggested';
        textFieldClassName += isDark ? ' is-dark' : '';
        textFieldClassName += (isDisabledInput ? ' is-disabled' : '');
        textFieldClassName += ' is-dark';
        const className = 'form-group-textfield-suggested-input' + (isDisabledInput ? ' is-disabled' : '') ;

        return (
            React.createElement("div", {className: textFieldClassName}, 
                React.createElement(TextFieldSuggested, {
                    readerAttribute: readerAttribute, 
                    items: items, 
                    itemsDisabled: itemsDisabled, 
                    readerAttributeValue: "id", 
                    className: className, 
                    floatingLabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    LabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    onChange: onChange, 
                    onBlur: this._onBlur, 
                    onEnterKeyDown: this._onEnter, 
                    value: value, 
                    floatingLabelText: label ? label : '', 
                    style: {width: '100%', color: 'white !important', fontWeight: '300'}, 
                    isDisabled: isDisabledInput, 
                    errorText: get(this.state, 'messageError', ''), 
                    onItemSelected: this.onItemSelected
                }
                )
            )
        );
    }
});

module.exports = FormGroupTextFieldSuggested;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested.jsx
 **/